import Swup from 'swup';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
// import Splide from '@splidejs/splide';
// import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { initializeFeaturedCards, initializeStackCards, calculateStackHeight, stackThrottle } from './cardstack.js';
import { heroRollover } from './hero.js';
import { ctaMatter } from './ctamatter.js';
import { lazyLoad } from 'unlazy';
import count from './components/count';
import intersect from '@alpinejs/intersect'
import SwupGaPlugin from '@swup/ga-plugin';


// Global Variables
window.isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.data('count', count)

// // Check if the splide element exists
// if (document.querySelector('.splide')) {
//     new Splide('.splide').mount();
// } else {
//     console.warn('Splide element not found');
// }

const options = {
    plugins: [
        new SwupScriptsPlugin({
            optin: true
        }),
        new SwupGaPlugin({
            gaMeasurementId: 'G-17TGJZZR44'
        })
    ]
};

const swup = new Swup(options);

// Events
swup.hooks.on('content:replace', init);

// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();


// When page is ready
document.addEventListener("DOMContentLoaded", () => init());

// Functions 
function l(m) {
    // console.log(m);
}

function init() {
    l('👍');
    // Apply lazy loading for all images by the selector `img[loading="lazy"]`
    lazyLoad()

    // init hero rollover
    if (document.querySelector('.hero')) {
        let hero = new heroRollover();
        hero.init();
    } else {
        if (typeof hero !== 'undefined') {
            l('hero exists');
            hero.destroy();
        } else {
            l('hero does not exist');
            let hero = '';
        }
    }
    
    if(document.querySelector('.wrap-darkmode')) {
        l('load white logo')
        const r = new rive.Rive({
            src: "../../assets/images/scoreplay-3.riv",
            canvas: document.getElementById("logo"),
            autoplay: true,
            stateMachines: "white",
            onLoad: () => {
                r.resizeDrawingSurfaceToCanvas();
            }
        });
    } else if(document.querySelector('.wrap-blog')) {
            l('load white logo')
            const r = new rive.Rive({
                src: "../../assets/images/scoreplay-3.riv",
                canvas: document.getElementById("logo"),
                autoplay: true,
                stateMachines: "white",
                onLoad: () => {
                    r.resizeDrawingSurfaceToCanvas();
                }
            });
        
    } else {
        l('load dark logo');
        const r = new rive.Rive({
            src: "../../assets/images/scoreplay-3.riv",
            canvas: document.getElementById("logo"),
            autoplay: true,
            stateMachines: "black",
            onLoad: () => {
                r.resizeDrawingSurfaceToCanvas();
            }
        });
    }

    // if (document.querySelector('.cta')) {
    //     loadMatter();
    // }

    initializeStackCards('stackCards', 'cta_item');
    initializeFeaturedCards();
    calculateStackHeight();
    stackThrottle();
    cycleImagesInit();
    
    if (document.querySelector('.cta_custom')) {
        ctaMatter();
    }

    const videos = document.querySelectorAll('video[autoplay]');
    videos.forEach(video => {
        video.play();
        console.log('📹 Video autoplaying');
    });

    // startStats();

}

// Animated Stats

// function animateStats(el, startVal, endVal, duration) {
//     let startTime = null;

//     function frame(time) {
//         if (!startTime) startTime = time;
//         const progress = Math.min((time - startTime) / duration, 1);
//         const currentVal = Math.round(startVal + (endVal - startVal) * progress);

//         el.textContent = `+${currentVal}%`;

//         if (progress < 1) {
//             requestAnimationFrame(frame);
//         }
//     }

//     requestAnimationFrame(frame);
// }

// function startStats() {
//     const statsEls = document.querySelectorAll('.stats_number');
    
//     if (!statsEls.length) return;

//     statsEls.forEach((el) => {
//         const endVal = parseInt(el.textContent.replace('+', '').replace('%', ''), 10);
//         let startVal = Math.max(endVal - 50, 0);
//         const duration = 2000;

//         animateStats(el, startVal, endVal, duration);
//     });
// }


// Flicker in mobile home

function cycleImagesInit() {
    const images = document.querySelectorAll('.hero_images--mobile img');
    if (images.length === 0) return;

    let currentIndex = 0;
    let cycleCount = 0;
    const totalCycles = 3;

    function cycleImages() {
        images[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].classList.add('active');

        if (currentIndex === 0) {
            cycleCount++;
        }

        // if (cycleCount >= totalCycles) {
        //     clearInterval(intervalId);
        //     const randomIndex = Math.floor(Math.random() * images.length);
        //     images.forEach((img, index) => {
        //         img.classList.remove('active');
        //         if (index === randomIndex) {
        //             img.classList.add('active');
        //         }
        //     });
        // }
    }

    const intervalId = setInterval(cycleImages, 500);
}


// // function startSliders() {
// //   if(document.querySelectorAll('.splide').length) { 
// //     let perPage = isMobile ? 1.5 : 3.5;
// //     let splide = new Splide( '.splide', {
// //       type: 'loop',
// //       focus  : 'left',
// //       perPage: perPage,
// //       arrows: true,
// //       pagination: false
// //     });

// //     splide.mount();
// //   }

// // }

// function cookieNotice() {
//   l('cookienotice');
//   document.querySelector('.cookie_btn').addEventListener('click', setCookie);
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   document.querySelector('.cookie').classList.add('hidden');
// }



document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.featured_item');

    const updateClassNames = () => {
        cards.forEach((card, index) => {
            card.className = `featured_item featured_item--${index + 1} ${card.classList.contains('active') ? 'active' : ''} ${card.classList.contains('last-item') ? 'last-item' : ''}`;
        });
    };

    const nextButton = document.querySelector('.next');
    const prevButton = document.querySelector('.prev');
    const featuredList = document.querySelector('.featured_list');

    if (nextButton && prevButton && featuredList && cards.length > 0) {
        nextButton.addEventListener('click', function () {
            l('Next button clicked, bro!');

            const activeCard = document.querySelector('.featured_item.active');
            if (activeCard) {
                activeCard.classList.remove('active');
                activeCard.classList.add('last-item'); // Add class for last item
                featuredList.appendChild(activeCard); // Move to end

                const nextCard = activeCard.nextElementSibling || document.querySelector('.featured_item:first-child');
                nextCard.classList.add('active');

                // Update class names based on new positions
                updateClassNames();
            }
        });

        prevButton.addEventListener('click', function () {
            l('Prev button clicked, bro!');

            const lastCard = document.querySelector('.featured_item.last-item');
            if (lastCard) {
                lastCard.classList.remove('last-item');
                featuredList.insertBefore(lastCard, document.querySelector('.featured_item:first-child')); // Move to front

                cards.forEach(card => card.classList.remove('active')); // Remove active from all
                lastCard.classList.add('active'); // Set as active

                // Update class names based on new positions
                updateClassNames();
            }
        });
    } else {
        // console.warn('Required elements not found');
    }
});



// document.querySelector('body').addEventListener('cookies:saved', ({detail}) => {
//   console.log('Saved cookie features:', detail);
// })